import { css } from 'linaria';
export const tagWrapper = "tchv94s";
export function TagBox({
  children
}) {
  return <div className={tagWrapper}>{children}</div>;
}

require("./tag.box.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag.box.js");